import { render, staticRenderFns } from "./UsersListTable.vue?vue&type=template&id=06f49443&"
import script from "./UsersListTable.vue?vue&type=script&lang=js&"
export * from "./UsersListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports